export interface KeyVal {
  id: string;
  value: string;
}

export interface AfFlag {
  introductionPercent: string;
  personalInfoPercent: string;
  addressPercent: string;
  educationPercent: string;
  employmentPercent: string;
  certificationPercent: string;
  criminalPercent: string;
  disclosuresPercent: string;
  authorizationsPercent: string;
}

export interface AFEntity {
  view: string;
  firstName: string;
  middleName: string;
  lastName: string;
  afId: string;
  email: string;
  jobState: string;
  jobCountry: string;
  introductionPercent: string;
  personalInfoPercent: string;
  addressPercent: string;
  educationPercent: string;
  employmentPercent: string;
  certificationPercent: string;
  criminalPercent: string;
  disclosuresPercent: string;
  authorizationsPercent: string;
  isSkipProfileCreation: string;
  isProfileCreated: string;
  unAuthorized: string;
  bookmarkUrl: string;
  navList: Array<AFNavigation>;
  isSwapsAP: boolean;
  countryRules: CountryRules;
  skinnyFlag: number;
}

export class AFIntroduction {
  welcome: string;
  submit: string;
  buttons: string;
  images: string;
  error: string;
  howLong: string;
  minutes: string;
  saveAndFinish: string;
  timeOut: string;
}

export class AFRegistrationDomain {
  afId: string;
  verifyId: string;
  aaLetterTokenId: string;
  username: string;
  password: string;
  otp: string;
  oldPassword: string;
  rePassword: string;
  question1: number;
  answer1: string;
  question2: number;
  answer2: string;
  question3: number;
  answer3: string;
  question4: number;
  answer4: string;
  question5: number;
  answer5: string;
  nationalIdTypeName: string;
  country: number;
  state: number;
  consent: boolean;
  consent2: boolean;
  questionLookup: KeyVal[];
  countryLookup: Map<number, string>;
  nationalIdTypeLookup: Map<number, string>;
  countryAuthorizeLookup: Map<number, string>;
  stateAuthorizeLookup: Map<number, string>;
  isSkipProfileCreation: Map<number, string>;
  isProfileCreated: boolean;
  isDisputeInitiated: boolean;
  errorMessage: string;
  warningMessage: string;
  vendorLoginAttempts: number;
  view: string;
  vendorSign: boolean = false;
}

export class AFPersonalInformation {
  afId: string;
  title: string;
  suffix: string;
  gender: string;
  primaryPhone: string;
  firstName: string;
  secondPhone: string;
  middleName: string;
  email: string;
  lastName: string;
  fatherFirstName?: string;
  fatherMiddleName?: string;
  fatherLastName?: string;
  birthDate: string;
  ssn: string;
  confirmSsn: string;
  prevBank: string;
  haveConnection: string;
  personNumber: string;
  bankAffiliate: string;
  otherName: string;
  nameType: Array<string>;
  otherFirstName: Array<string>;
  otherMiddleName: Array<string>;
  otherLastName: Array<string>;
  otherNameId: Array<string>;
  dateNameChange: Array<string>;
  otherNameList: Array<OtherNamePojo>;
  genderLookup: KeyVal[];
  bankAffiliatesLookup: KeyVal[];
  nameTypeLookup: KeyVal[];
  prevBankFromDate: any;
  prevBankEndDate: any;
  dateOfBirthMonth: string;
  dateOfBirthDay: string;
  dateOfBirthYear: string;
  dateDiff: string;
  monthLookup: KeyVal[];
  currentContractor: string;
  lockBoxFlag: string;
  jcaKey: string;
  applicantType: string;
  countryRules: CountryRules;
  countryOfBirth: string;
  jobCountryValue: string;
  displayPepQuestion: boolean;
  nationalIdType: number;
  nationalId: string;
  inputOusMonth: string;
  inputOusDay: string;
  inputOUsYear: string;
  usCitizen: string;
  usGreenCard: string;
  usGreenCardDocumentNumber: string;
  usGreenCardIssueMonth: string;
  usGreenCardIssueDay: string;
  usGreenCardIssueYear: string;
  usGreenCardExpiryMonth: string;
  usGreenCardExpiryDay: string;
  usGreenCardExpiryYear: string;
  usGreenCardSSN: string;
  motherOrFather: number;
  skinnyFlag: string;
}

export class OtherNamePojo {
  otherNameId: string;
  nameType: string;
  otherFirstName: string;
  otherMiddleName: string;
  otherLastName: string;
  orderNumber: string;
  dateNameChange: any;
}

export class CountryRules {
  countryCd: string;
  jobSubCountry: string;
  countryOfBirth: number;
  addressLimit: number;
  jobCountryValue: string;
  otherNameText: string;
  employmentGapInstruction: number;
  addressHistoryInstruction: number;
  outsideJobCountryDocument: number;
  educationHistoryInstruction: string;
  licenseIdText: string;
  requiredDocumentJobCountry: string;
}

export class AFEmploymentPojo {
  isCurrentEmployer: string;
  canContactNow: string;
  employmentType: string;
  employerName: string;
  addressId: string;
  businessTypeEmployer: string;
  salary: string;
  salaryCurrency: string;
  salaryFrequency: string;
  bonus: string;
  bonusCurrency: string;
  bonusFrequency: string;
  bonusType: string;
  isRegulatorRegistered: string;
  hasAgency: string;
  agencyAddress: string;
  umbrellaPayeeAddressId: string;
  referredBy: string;
  reason: string;
  otherReason: string;
  workDescription: string;
  position: string;
  businessPhoneNumber: string;
  employerWebsite: string;
  managerName: string;
  managerPhoneNumber: string;
  managerEmailAddress: string;
  natureOfEmployment: string;
  managerDesignation: string;
  managerStillEmployed: string;
  disciplinedFinedWarnedDtls: string;
  agencyName: string;
  agencyContactDetails: string;
  idNumber: string;
  otherIdTypeDesc: string;
  agencyPhoneNumber: string;
  umbrellaPayeePhoneNumber: string;
  umbrellaPayeeName: string;
  umbrellaPayeeEmail: string;
  employeeId: string;
  contactDate: string;
  employmentStartDate: any;
  employmentEndDate: any;
  regulatorFromDate: string;
  regulatorToDate: string;
  reasonCode: string;
  addnlDetailsForRFL: string;
  streetAddressOne: string;
  city: string;
  zipCode: string;
  streetAddressTwo: string;
  country: string;
  streetAddressThree: string;
  state: string;
  usState: string;
  reasonCodeForLeavingLookup: KeyVal[];
  isCurrentEmploymentStatus: string;
  employmentBreakReason: string;
  employmentBreakComment: string;
  employmentBreakFromDate: any;
  employmentBreakToDate: any;

  currentDojProofId: string;
  currentDesignationProofId: string;
  currentOfferLetterId: string;
  currentCompensationLetterId: string;
  currentLatestThreePaySlipId: string;
  previousDojProofId: string;
  previousDesignationProofId: string;
  lwdProofId: string;
  previousOfferLetterId: string;
  previousCompensationLetterId: string;
  previousLastThreeMonthPaySlipId: string;
}

export class AFEmploymentDomain {
  submit: boolean;
  afId: number;
  countryLookup: KeyVal[];
  usStateLookup: KeyVal[];
  currencyLookup: KeyVal[];
  salaryFreqLookup: KeyVal[];
  typeOfEmployerLookup: KeyVal[];
  typeOfEmploymentLookup: KeyVal[];
  reasonForLeavingLookup: KeyVal[];
  reasonEmploymentBreakLookup: KeyVal[];
  natureOfEmploymentLookup: KeyVal[];
  bonusTypeLookUp: KeyVal[];
  emptyEmpBreak: boolean;
  emptyEmpHistory: boolean;
  noEmploymentHistory: boolean;
  employmentCount: number;
  lockBox: boolean;
  employmentList: Array<AFEmploymentPojo>;
  employmentBreakList: Array<AFEmploymentPojo>;
  employmentLimit: number;
  jobCountry: string;
  countryMismatchFlag: string;
  employmentVerificationDate: any;
}

export class AFEducationPojo {
  educationInstitutionName: string;
  educationInstitutionType: string;
  educationInstitutionZip: string;
  educationInstitutionCity: string;
  educationInstitutionState: string;
  educationInstitutionUsState: string;
  educationInstitutionCountry: string;
  educationStartDate: any;
  educationEndDate: any;
  course: string;
  isCompleted: string;
  degreeType: string;
  gradeGpa: string;
  degreeCopy: string;
  graduationDate: any;
  nameWhileAttending: string;
  commt: string;
  eduInstStreetAddress1: string;
  eduInstStreetAddress2: string;
  eduInstStreetAddress3: string;
  mongoAttachmentId: string;
  attachementTypeId: number;
}

export class AFEducationHistoryDomain {
  submit: boolean;
  afId: number;
  verifyId: string;
  noEducationHistory: boolean;
  lockBox: boolean;
  degreeRequiredFlag: string;
  campusHireFlag: string;
  lockBoxFlag: string;
  finraRegisteredFlag: string;
  secFlag: string;
  usTrustBioEmail: string;
  educationLimit: number;
  educationList: Array<AFEducationPojo>;
  countryLookup: KeyVal[];
  typeOfDegreeLookup: KeyVal[];
  typeOfEducationInstLookup: KeyVal[];
  usStateLookup: KeyVal[];
  jobCountryId: number;
  attachmentList: Array<Attachment>;
  gbsEducationHisProofAttachmentList: Array<OusCountryAttachmentType>;
}

export class AFAddressHistoryDomain {
  submit: boolean;
  afId: number;
  militaryBase: string;
  eligibility: string;
  haveYouLivedOUS: number;
  haveYouLivedOutsideJobCountry: number;
  addressLimit: number;
  ousQuestionEligible: string;
  ousFieldsList: Array<string>;
  ousAttachmentList: Array<OusCountryAttachmentType>;
  requiredOusAttachmentList: Array<OusCountryAttachmentType>;
  visaSponsorShipRequired: string;
  authorised: string;
  lockBoxFlag: string;
  addressList: Array<AFAddressPojo>;
  countryLookup: KeyVal[];
  usStateLookup: KeyVal[];
  activeCpaStates: Array<string>;
  jobStateId: string;
  jobCountryId: number;
  attachmentList: Array<Attachment>;
  gbsAddressHisProofAttachmentList: Array<OusCountryAttachmentType>;
}

export class AFLocationConfirmation {
  verifyId: string;
  submit: boolean;
  afId: number;
  currentAddress: AFAddressPojo;
  changedAddress: AFAddressPojo;
  usingCurrentAddress: string;
  addressConfirmed: boolean;
  countryLookup: KeyVal[];
  usStateLookup: KeyVal[];
  bookmarkUrl: string;
}

export class AfPcDomain {
  verifyId: string;
  submit: boolean;
  afId: string;
  pcType: string;

  //radio buttons must be null, '1' or '0'
  mbamOutsideEmployment: string;
  mbamMemberCompany: string;
  mbamElectedOfficial: string;
  mbamMemberCommitee: string;
  mbamComment: string;
  afPcDetails: Array<AfPcDetails>;

  pcCandidateList: Array<AfPcDetails>;
  pcLocalPartiesList: Array<AfPcDetails>;
  pcPacsList: Array<AfPcDetails>;
  pcGbamList: Array<AfPcDetails>;

  bookmarkUrl: string;
  contribution: string;

  //GWIM
  pcGwimAccepted: boolean;
  pcGwimSignedName: string;
  pcGwimWetSignatureDate: any;
  pcGwimSignature: string;

  gwimVoteForCandidate: string;

  //GBAM
  pcGbamAccepted: boolean;
  pcGbamSignedName: string;
  pcGbamWetSignatureDate: any;
  pcGbamSignature: string;

  //MBAM
  pcMbamAccepted: boolean;
  pcMbamSignedName: string;
  pcMbamWetSignatureDate: any;
  pcMbamSignature: string;

  pcPosition: string;
  pcGroup: string;

  pcOfficeLookup: KeyVal[];
  pcElectionTypeLookup: KeyVal[];
}

export class AfPcDetails {
  id: string;
  afId: number;
  pcType: string;
  recipientName: string;
  contributionDate: any;
  contributionDateStr: string;
  officeRunning: string;
  amount: string;
  address: string;
  officeHeld: string;
  subdivision: string;
  contributionType: string;
}

export class OusCountryAttachmentType {
  attachmentId: string;
  attachmentName: string;
  downloadble: number;
  attachmentCheck: boolean;
  mongoAttachmentId: string;
}

export class AFAddressPojo {
  afId: number;
  addressId: number;
  orderNumber: number;
  isCurrentAddress: string;
  startDate: any;
  endDate: any;
  city: string;
  county: string;
  streetAddress1: string;
  country: string;
  streetAddress2: string;
  state: string;
  usState: string;
  streetAddress3: string;
  zipCode: string;
  militaryBase: string;
  motherMaidenName: string;
  motherFirstName: string;
  motherMiddleName: string;
  motherLastName: string;
  fatherFirstName: string;
  fatherMiddleName: string;
  fatherLastName: string;
  countryOfBirth: string;
  townOfBirth: string;
  showMotherName: boolean;
  showFatherName: boolean;
  showBirthPlace: boolean;
  showMotherMaidenName: boolean;
  ousFields: Array<string>;
  checkTwo: boolean;
  countryValue: string;
  mongoAttachmentId: string;
  attachementTypeId: number;
}

export class OusData {
  showMotherName: boolean;
  showFatherName: boolean;
  showBirthPlace: boolean;
  showMotherMaidenName: boolean;
  ousFields: Array<string>;
  ousAttachmentList: Array<OusCountryAttachmentType>;
  countryList: Array<string>;
  countryId: string;
}

export class AFAuthorization {
  submit: boolean;
  afId: number;
  output: string;
  signatureDate: string;
  alternateAuthorization: string;
  applicantName: string;
  alternateCheck: boolean;
  attachmentList: Array<Attachment>;
  authorizeConsent: boolean;
  authorizeConsentDate: string;
  stateConsumerReportDate: string;
  isStateAuthorised: string;
  signature: string; //changing from the SignatureLine[] array and storing the image string
  languageLookup: KeyVal[];
  authLanguageLookup: string;
  fcraLegalRequirementsMet: boolean;
  fcraApplicantSignedName: string;
  fcraLegalRequirementCheckDate: any;
  fcraLegalRequirementCheckDateHidden: string;
  lockBoxFlag: string;
}

export class AFConsent {
  submit: boolean;
  afId: number;
  lockBoxFlag: string;
  certificationCheck: boolean;
  consentLegalRequirementsMet: boolean;
  certificationCheckDate: string;
  ousQuestionEligible: string;
  ousMilitaryCheck: string;
  haveYouLivedOUS: string;
  output: string;
  signatureDate: string;
  applicantName: string;
  consentApplicantSignedName: string;
  consentLegalRequirementCheckDate: string;
  isMinor: string;
  signature: string;
  descOfTheFileLookup: string;
  languageLookup: KeyVal[];
  fileDescriptionLookup: KeyVal[];
  certificationLanguageLookup: KeyVal[];
  attachmentList: Array<Attachment>;
  ousAttachmentList: Array<OusCountryAttachmentType>;
  browserName: string;
  browserVersion: string;
  jobCountry: string;
  skinnyFlag: string;
}

export class AFCertificationPojo {
  organizationCountry: string;
  isCurrentMemberShip: string;
  licenseName: string;
  licenseType: string;
  licenseIdNumber: string;
  professionalOrganizationName: string;
  organizationCity: string;
  organizationState: string;
  organizationUsState: string;
  organizationZip: string;
  typeOfMemberShip: string;
  organizationWebsite: string;
  commt: string;
  licenseOriginationDate: any;
  licenseValidDate: any;
  graduationDate: any;
}

export class AFCertificationDomain {
  verifyId: string;
  noCertification: boolean;
  noCertificationBand: boolean;
  certTypeLookup: KeyVal[];
  countryLookup: KeyVal[];
  usStateLookup: KeyVal[];
  submit: boolean;
  afId: number;
  certificationList: Array<AFCertificationPojo>;
}

export class AFSubmitResponse {
  status: string;
  submit: boolean;
  attachmentId: string;
  url: string;
  showAuthPage: boolean;
}

export class Attachment {
  attachmentId: string;
  mongoAttachmentId: string;
  afId: number;
  fileName: string;
  descriptionOfFile: number;
  descOfFileName: string;
  typeOfAttachmentId: string;
  attachedDateString: string;
  fileType: string;
  afBlob: AFBlob;
  fileSize: number;
  attachedBy: string;
  attachedByFirstName: string;
  attachedByLastName: string;
  attachedByStandardId: string;
  attachedDate: Date;
  updatedBy: number;
  updatedDt: Date;
  deleteFlg: number;
}

export class CriminalOffensePojo {
  criminalOffenseId: number;
  orderNumber: number;
  offenseOrRegulatoryAction: string;
  levelOfOffense: string;
  cityOrTown: string;
  stateOrProvince: string;
  usState: string;
  county: string;
  country: string;
  dateOfOffense: any;
  dateOfArrest: any;
  dateOfDisposition: any;
  disposition: string;
  sentence: string;
  explanation: string;
  othrCmtOffenseType: string;
  othrCmtLevelOfOffense: string;
  othrCmtDisposition: string;
}
export class AFCountryAnswersDomain {
  id: number;
  af_id: number;
  question_id: number;
  questions: string;
  answer: number;
  description: string;
  country_cd: string;
  category: string;
}

export class AFCriminalHistoryDomain {
  submit: boolean;
  afId: number;
  verifyId: string;
  creditAssignedFlag: string;
  safeRegistrationFlag: string;
  usCriminalNMLSNumber: string;
  usCriminalUnsatisfiedComments: string;
  awaitTrialFlag: string;
  usCriminalAwaitTrial: string;
  pendingChargesFlag: string;
  usCriminalPending: string;
  convictedOffenseFlag: string;
  usCriminalConvictions: string;
  dispositionAdjudicationFlag: string;
  usCriminalDispositions: string;
  subjectInvestigationFlag: string;
  usCriminalSubjectInvestigation: string;
  usCriminalSubjectInvestigationComments: string;
  respondentFinancialFlag: string;
  usCriminalRespondentFinancial: string;
  usCriminalRespondentFinancialComments: string;
  usCriminalCreditAssigned: string;
  usCriminalSafeRegistration: string;
  criminalOffenseList: Array<CriminalOffensePojo>;
  offenseLevelLookup: KeyVal[];
  countryLookup: KeyVal[];
  usStateLookup: KeyVal[];
  dispositionlookup: KeyVal[];
  offenseTypelookup: KeyVal[];
  afCountryQuestionsList: Array<AFCountryAnswersDomain>;

  swapsDisciplinaryAction: string;
  swapsDisciplinaryActionDetails: string;
  swapsRevocation: string;
  swapsRevocationDetails: string;
  swapsInjunction: string;
  swapsInjunctionDetails: string;
  swapsRecordofArrest: string;
  swapsRecordofArrestDetails: string;
}

export class AFOtherBgcInfo {
  output: string;
  signatureDate: string;
  applicantName: string;
  otherBgcLegalRequirementsMet: boolean;
  otherBgcApplicantSignedName: string;
  otherBgcLegalRequirementCheckDate: string;
  otherBgcLegalRequirementCheckDateHidden: string;
  isCAStateDisclosure: string;
  isOKStateDisclosure: string;
  isMNStateDisclosure: string;
  languageLookup: string;
  afId: string;
  firstSection: string;
  californiaOne: string;
  californiaTwo: string;
  maryland: string;
  massachusetts: string;
  minnesotaOne: string;
  minnesotaTwo: string;
  newYork: string;
  nyc: string;
  oklahoma: string;
  rhodeIsland: string;
  vermont: string;
  lastSection: string;
}

export class AFCpaInfo {
  submit: boolean;
  afId: number;
  output: string;
  signature: string;
  signatureDate: string;
  caStateVerbiage: string[];
  cpaLegalRequirementsMet: boolean;
  cpaSignedName: string;
  cpaRequirementsBgcCheckDate: any;
}

export class AFSummaryOfRights {
  languageLookup: string;
}

export class AFDisclosure {
  afId: string;
  relatives: string;
  investigation: string;
  investigationComments: string;
  outsideBusinessQuestion1: string;
  employedCompensated: string;
  race: string;
  discTermsCheck: boolean;
  discTermsCheckDate: string;
  discStatsCheck: boolean;
  discStatsCheckDate: string;
  chnCookiesDisc: boolean;
  chnPDDisc: boolean;
  chnThirdDisc: boolean;
  chnTransferDisc: boolean;
  descOfTheFile: string;
  employeeOfEntity: string;
  positionInEntity: string;
  nameOfEntity: string;
  contactWithEntity: string;
  entityDetails: string;
  output: string;
  signatureDate: string;
  applicantName: string;
  relativeList: Array<RelativePojo>;
  relationshipLookup: KeyVal[];
  raceLookup: KeyVal[];
  languageLookup: KeyVal[];
  authLanguageLookup: string;
  legalRequirementsMet: boolean;
  applicantSignedName: string;
  legalRequirementCheckDate: string;
  //Flags
  relativeFlag: string;
  raceFlag: string;
  pendingInvestigationFlag: string;
  directorFlag: string;
  revolvingDoorFlag: string;
}

export class RelativePojo {
  relativeId: string;
  relativeName: string;
  relationship: string;
  orderNumber: string;
}

export class AFBlob {
  blobId: number;
  content: any;
  createdBy: number;
  createdDt: Date;
  disabled: number;
  orderId: number;
  updatedBy: number;
  updatedDt: Date;
  afid: number;
}

export class AFNavigation {
  id: number;
  name: string;
  routerLink: string;
}

export class SignInModel {
  verifyId: string;
  username: string;
  password: string;
  newPassword: string;
  confirmNewPassword: string;
  warningMessage: string = "";
  errorMessage: string = "";
  vendorSign: boolean = false;
  nhpSign: boolean = false;
}

export class AFDisputeQuestionPojo {
  disputeQuestionAnswer: Array<LkpAsiDisputeQuestion>;
  disputeQuestionAnswerId: string[];
  question: string[];
  questionOrder: string[];
  asiAttachments: Array<AsiAttachments>;
  disputeQuestionAttachment: Array<any>; //MultipartFile
  asiCaseId: number;
  asiComponentId: number;
  applicantFormId: number;
}

export class AsiAttachments {
  attachmentId: number;
  caseId: number;
  componentId: number;
  fileType: string;
  attachedDt: any;
  attachedBy: number;
  attachmtFileBlobId: AsiBlob;
  attachmtFileName: string;
}

export class AsiBlob {
  blobId: number;
  blobContent: any;
  createdBy: number;
  createdDt: Date;
  updatedBy: number;
  updatedDt: Date;
  contentType: string;
  docName: string;
}

export class LkpAsiDisputeQuestion {
  questionId: number;
  questionName: string;
}

export class UserNavigationals {
  userMapNavigations: string[];
}

export class RadioGroupButtonModel {
  groupName: string = "";
  groupValue: string = "";
}

export class DisputeFileUpload {
  verifyId: string;
  asiComponentId: string;
  asiCaseId: string;
  applicantFormId: string;
}

export class VendorRequestDomain {
  fingerPrintCheck: boolean;
  actionBaseCheck: boolean;
  ewsCheck: boolean;
  applicantFormCheck: boolean;
  credit: boolean;
  ssnValidation: boolean;
  ssnTrace: boolean;
  nationalCriminalDatabase: boolean;
  countyCriminal: boolean;
  federalCriminal: boolean;
  componentsCheck: boolean;
  lockboxCheck: boolean;
  firstName: string;
  middleName: string;
  email: string;
  lastName: string;
  suffix: string;
  country: string;

  jobCountry: string;
  vendorAccount: string;
  vendorAccountName: string;
  vendorName: string;
  refNum: string;
  costCenter: string;
  mailCode: string;

  vendorFirstName: string;
  vendorMiddleName: string;
  vendorLastName: string;
  vendorEmailAddress: string;
  vendorAccountSerialNum: string;

  countryLookup: KeyVal[];
  vendorAccountLookup: KeyVal[];
  vendorAccountMap: KeyVal[];
  vendorNameMap: KeyVal[];

  profileId: number;
}

export class VendorResultsDomain {
  caseNumber: string;
  applicantName: string;
  requesterName: string;
  comp: string;
  caseStatus: string;
  statusDate: string;
  applicantStatus: string;
  appointmentDetails: string;
  auditIds: string;
  containerId: number;
  entityId: string;
  referenceNumber: string;
}

export class VendorTakeActionDomain {
  caseNumber: string;
  applicantName: string;
  verifyId: string;
  auditIds: string;
  templateName: string;
  dateSent: string;
  sentTo: string;
  sentCC: string;
  sentBCC: string;
  containerId: number;
  entityId: string;
  emailAddress: string;
  auditId: number;
}

export class AFDirectorshipsDomain {
  afId: string;
  directorshipStatus: KeyVal[];
  director: string;
  compensated: string;
  afDirectorshipsList: Array<AFDirectorships>;
}

export class AFDirectorships {
  companyName: string;
  startDate: any;
  endDate: any;
  status: string;
  comments: string;
  lastAccountFixedDate: any;
  vatRegNumber: string;
}

export class AFVendorBatchRequestDomain {
  noOfBatchRequests: number;
  noOfPages: number;
  pageNo: number;
  startPage: number;
  endPage: number;
  vendorAccount: string;
  vendorAccountMap: KeyVal[];
  attachmentId: string;
  vendorAccountSerialNum: string;
  batchRequestFiles: Array<AFVendorBatchRequest>;
}

export class AFVendorBatchRequest {
  uploadId: number;
  fileSize: number;
  verifyId: string;
  vendorFirstName: string;
  vendorMiddleName: string;
  vendorLastName: string;
  fileName: string;
  uploadDate: any;
  uploadDateString: string;
}

export class AFVendorResponseDomain {
  applicantName: string;
  requesterName: string;
  componentsRequested: string;
  caseStatus: string;
  statusDate: string;
  caseNumber: string;
  referenceNumber: string;
  applicantFirstName: string;
  applicantLastName: string;
  requesterFirstName: string;
  requesterLastName: string;
  vendorName: string;
  vendorAccount: string;
  vendorAccountLookup: Map<number, string>;
  ssn: string;
  confirmSsn: string;
  startDateBegin: string;
  startDateEnd: string;
  position: string;
  companyCostCenter: string;
  verifyId: string;
}

export class AFVendorRequest {
  afId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
  emailAddress: string;
  country: number;
  account: number;
  vendorName: string;
  jobCountry: number;
  refNumber: string;
  companyCode: string;
  mailCode: string;
  costCenter: string;
  vendorId: number;
  responseId: string;
  errorRefId: string;
  errorMsg: string;
}

export class SnackBarErrorData {
  errorMsg: string;
  action: string;
  ariaLabel: string;
}

export const AF_CONSTANTS = {
  windowWidth: 935,
  windowHeight: 470,
  empWindowHeight: 700,
  windowScroll_Lower_limit: 187,
  windowScroll_Upper_limit_employment: 2400,
  windowScroll_Upper_limit_address: 950,
  windowScroll_Upper_limit_education: 1500,
  windowScroll_Upper_limit_certification: 950,
  windowScroll_Upper_limit_criminal: 1380,
  emptyCanvas:
    "data:image/png;base64,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",
};
